<template>
  <div v-if="skeleton" class="card shadow bank-accounts bank-background p-3">
    <div class="d-flex justify-content-between flex-column h-100">
      <div class="d-flex w-100 justify-content-between">
        <b-skeleton width="150px"></b-skeleton>
        <b-skeleton width="150px"></b-skeleton>
      </div>
      <div class="w-100 py-3">
        <div class="chip mb-2"></div>
        <b-skeleton width="80%" height="1.5em"></b-skeleton>
      </div>
      <div class="d-flex justify-content-between align-items-end">
        <div>
          <b-skeleton width="100px"></b-skeleton>
          <b-skeleton width="200px" height="1.5em"></b-skeleton>
        </div>
        <img src="@/assets/svg/mastercard-symbol.svg" style="height: 32px" />
      </div>
    </div>
  </div>
  <div v-else class="card shadow bank-accounts bank-background p-3">
    <div class="d-flex justify-content-between flex-column h-100">
      <div class="d-flex w-100 justify-content-between">
        <p class="fw-bold header-card">{{ bank.branch_name }}</p>
        <p class="fw-bold header-card">{{ bank.bank_name }}</p>
      </div>
      <div class="center-number">
        <div class="chip mb-2"></div>
        <h4 class="account-number">{{ accountNumber }}</h4>
      </div>
      <div class="d-flex justify-content-between align-items-end">
        <div>
          <p class="mb-0 header-card">Owner</p>
          <h5 class="mb-0 owner-name">{{ bank.owner_name }}</h5>
        </div>
        <img src="@/assets/svg/mastercard-symbol.svg" style="height: 32px" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BankCard",
  props: {
    bank: {},
    accountNumber: String,
    skeleton: Boolean,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Orbitron:wght@400;500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;400;500;700&display=swap");

.bank-accounts {
  font-family: "Inconsolata", sans-serif !important;
  text-transform: uppercase !important;
}
.header-card {
  font-size: 0.6rem;
}
.account-number{
  font-size: 1rem;
}
.bank-accounts {
  font-family: "Inconsolata", sans-serif !important;
  text-transform: uppercase !important;
}
.bank-accounts h4,
.bank-accounts h5 {
  font-weight: 400 !important;
}
@media (max-width: 365px) {
  .bank-accounts {
    width: 300px !important;
  }
  .bank-account-number {
    font-size: 1.5rem;
  }
}
.bank-accounts {
  color: #fff;
  width: 400px;
  margin-right: 1rem;
  flex-shrink: 0;
  position: relative;
  border-radius: 10px !important;
}
.bank-background {
  background-image: url("~@/assets/svg/bank-card-background.svg");
  background-size: cover;
}
.bank-name {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 !important;
}
.chip {
  background-image: url("~@/assets/svg/chip.svg");
  width: 46px;
  height: 32px;
  background-size: cover;
  background-position: center;
  border-radius: 4px;
}
@media (min-width: 319px) {
}

@media (min-width: 374px) {
}

@media (min-width: 424px) {
}

@media (min-width: 767px) {
  .header-card {
    font-size: 1rem;
  }
  .account-number{
    font-size: 1.5rem;
  }
  .owner-name{
    font-size: 1.25rem;
  }
}

@media (min-width: 1023px) {
}

@media (min-width: 1439px) {
}

@media (min-width: 2000px) {
}
</style>